/**
 * Central registry of label overrides applied when the Dreamcoat Frame
 * feature flag is enabled. Each key maps to an i18n key.
 *
 * Most entries map to `dreamcoat.pageTitles.*` and feed both `<Meta>`
 * (browser tab) and `AppFrameConfig`/`StickyCard` headings. A small number
 * of related in-page label swaps (e.g. an Events table column header that
 * becomes "Action" alongside the "Action Log" page heading) map to
 * `dreamcoat.tableLabels.*` so the hook can keep both labels in sync from
 * a single registry.
 *
 * When the Dreamcoat Frame flag is retired and these become the default,
 * callers can either inline the strings or simplify `useDreamcoatPageTitle`
 * to always return the registry value.
 */
export const DREAMCOAT_PAGE_TITLES = {
  actionLog: 'dreamcoat.pageTitles.actionLog',
  actionLogEventColumn: 'dreamcoat.tableLabels.action',
  availabilitySchedules: 'dreamcoat.pageTitles.availabilitySchedules',
  booking: 'dreamcoat.pageTitles.booking',
  dependentBooking: 'dreamcoat.pageTitles.dependentBooking',
  exercisesFinder: 'dreamcoat.pageTitles.exercisesFinder',
  groupsFinder: 'dreamcoat.pageTitles.groupsFinder',
  measurements: 'dreamcoat.pageTitles.measurements',
  myAssessments: 'dreamcoat.pageTitles.myAssessments',
  myResources: 'dreamcoat.pageTitles.myResources',
  myVideos: 'dreamcoat.pageTitles.myVideos',
  myWorkoutPlans: 'dreamcoat.pageTitles.myWorkoutPlans',
  newAvailability: 'dreamcoat.pageTitles.newAvailability',
  nutrition: 'dreamcoat.pageTitles.nutrition',
  performance: 'dreamcoat.pageTitles.performance',
  plansFinder: 'dreamcoat.pageTitles.plansFinder',
  productsInventory: 'dreamcoat.pageTitles.productsInventory',
  recurringMembers: 'dreamcoat.pageTitles.recurringMembers',
  snapshot: 'dreamcoat.pageTitles.snapshot',
  staff: 'dreamcoat.pageTitles.staff',
  visits: 'dreamcoat.pageTitles.visits',
} as const;

export type DreamcoatPageTitleKey = keyof typeof DREAMCOAT_PAGE_TITLES;
